<template>
  <div class="ml-dropdown export-dropdown" ref="exportDropdown">
    <div class="ml-dropdown-toggle" @click="toggleDropdown">
      {{ $t('COMMON.EXPORT') }}
      <span class="arrow">&#9662;</span>
    </div>

    <div v-if="isOpen" class="ml-dropdown-menu">
      <div class="ml-dropdown-item" @click="export_excel_clicked($event)">
        <i class="fa fa-file mr-2 color-primary"></i>
        {{ $t('EXPORT.EXCEL') }}
      </div>

      <div class="ml-dropdown-item" @click="export_member_letter_labels_clicked">
        <i class="fa fa-file mr-2 color-primary"></i>
        {{ $t('EXPORT.LETTER_LABELS') }}
      </div>
    </div>

    <memlist-modal ref="success-job">
      <div class="row text-center">
        <div class="col-12">
          <i class="fa fa-check-circle" style="font-size: 42px; color: #8dda8d;"></i>
        </div>
        <div class="col-12 mt-3" style="border-top: 1px solid #ebedf2; padding-top: 20px;">
          <h4 class="event-name">{{ $t('PAGES.JOBS.CREATED') }}</h4>
          <br />
          <p>{{ $t('EXPORT.MEMBER_LETTERS_CREATED') }}</p>
        </div>
      </div>
    </memlist-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import { downloadWithAxios, get_base_url } from '@/core/services/fileDownload';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'ExportDropdown',
  mixins: [toasts],
  props: ['column_names', 'search_options'],
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'periods']),
  },
  mounted() {
    document.addEventListener('click', this.onClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    onClickOutside(event) {
      if (!this.$refs.exportDropdown.contains(event.target)) {
        this.isOpen = false;
      }
    },
    async get_member_ids_from_search_options() {
      try {
        const res = await axios.post(`/search/pagination/options/ids`, { search_options: this.search_options });
        return res.status === 200 ? res.data : [];
      } catch {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('ADVANCED_SEARCH.UNABLE_TO_SEARCH'));
        return [];
      }
    },
    async export_member_letter_labels_clicked() {
      if (!this.search_options) {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('ADVANCED_SEARCH.NO_RECORDS_IN_SELECTION'));
        return;
      }

      const loader = this.$loading.show();
      try {
        const member_ids = await this.get_member_ids_from_search_options();
        if (member_ids.length === 0) {
          loader.hide();
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('ADVANCED_SEARCH.NO_RECORDS_IN_SELECTION'));
          return;
        }

        const res = await axios.post('/export/letter_labels/member/query', { search_options: this.search_options });
        if (res.status === 201) {
          loader.hide();
          this.$refs['success-job'].show();
        } else {
          loader.hide();
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.UNABLE_EXPORT'));
        }
      } catch (err) {
        loader.hide();
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.UNABLE_EXPORT'));
      }
    },
    async export_excel_clicked(e) {
      e.preventDefault();
      if (!this.search_options) {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('ADVANCED_SEARCH.NO_RECORDS_IN_SELECTION'));
        return;
      }

      try {
        const localeMessages = this.$i18n.getLocaleMessage(this.$i18n.locale);
        const memberTranslations = localeMessages.MEMBER;

        const res = await axios.post('/search/pagination/options/xlsx', {
          search_options: this.search_options,
          columns: this.column_names,
          company_id: this.currentCompanyId,
          translations: memberTranslations,
        });

        if (res.status === 201) {
          downloadWithAxios(get_base_url() + `/dlfile/${res.data.linkstr}`, res.data.name);
          this.toastr('success', this.$t('COMMON.OK'), this.$t('COMMON.EXPORT_SUCCESS'));
        } else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.UNABLE_EXPORT'));
        }
      } catch {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.UNABLE_EXPORT'));
      }
    },
  },
};
</script>

<style scoped>
.export-dropdown {
  position: relative;
  max-width: 200px;
}

.ml-dropdown-toggle {
  padding: 10px 14px;
  border: 1px solid #3699ff;
  border-radius: 4px;
  background: white;
  color: #3699ff;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  height: 40px;
}

.arrow {
  font-size: 0.75rem;
  margin-left: 8px;
}

.ml-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 5px;
  z-index: 500;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1);
}

.ml-dropdown-item {
  padding: 12px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s;
}

.ml-dropdown-item:hover {
  background-color: #f3f6f9;
}

.color-primary {
  color: #3699ff;
}
</style>
